import { Component, EventEmitter, Injectable } from '@angular/core';
import { Subject, Subscriber } from 'rxjs';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class CustomCriteriaService {

  private modalSubject = new Subject<any>();
  typeChangeEventEmitter: EventEmitter<any>;
  private resultado: string;
  public vTip: string;
  public expresionValida: boolean;

  constructor() {
    this.typeChangeEventEmitter = new EventEmitter(true);
  }

  showModal(): Subject<any> {
    return this.modalSubject;
  }

  closeModal(value: any): void {
    this.modalSubject.next(value);
    this.modalSubject.complete();
  }

  updateFieldType(tipo: string){
    this.typeChangeEventEmitter.emit(tipo)
  }


  public validateValue(expre: string, value: any, tipo: string): boolean {

    if(value == undefined || value == null || value == '' || expre == '' || expre == undefined || expre == null){
      return true;
    }
    var criteriaParsed = expre[0].toUpperCase();
    var currentValue = this.generateSourceValue(value,tipo);
    var continueSearching = true;
    var startPosition = 0;
    do{
        var startOfValue = this.findNextOperatorEnd(criteriaParsed,startPosition);
        if(startOfValue != -1){
          var endOfValue = this.findValueEnd(criteriaParsed,startOfValue);
          var valueTarget = this.generateTargetValue(criteriaParsed.substring(startOfValue,endOfValue),currentValue,tipo);
          criteriaParsed = criteriaParsed.substring(0,startOfValue) + valueTarget + criteriaParsed.substring(endOfValue);
          startPosition = endOfValue;
        }else{
          continueSearching = false;
        }
    }while(continueSearching);

    //Ponemos los valores actuales
    startPosition = 0;
        continueSearching = true;
        do{
            var startOfValue = this.findNextOperator(criteriaParsed,startPosition);
            if(startOfValue != -1){
                criteriaParsed = criteriaParsed.substring(0,startOfValue) + currentValue + criteriaParsed.substring(startOfValue);
                startPosition = startOfValue + currentValue.length +1;
            }else{
                continueSearching = false;
            }
        }while(continueSearching);
    criteriaParsed = criteriaParsed.replace("AND","&&")
                .replace("OR","||");

    console.log(criteriaParsed);
    return eval(criteriaParsed);
  }
  findNextOperator(cadena: string, startPosition: number) {
    var nv = cadena.length;
        var n = cadena.indexOf(">=",startPosition);
        if(n != -1 && n < nv){
            nv= n;
        }
        n = cadena.indexOf("<=",startPosition);
        if(n != -1 && n < nv){
            nv= n;
        }
        n = cadena.indexOf("<",startPosition);
        if(n != -1 && n < nv){
            nv= n;
        }
        n = cadena.indexOf(">",startPosition);
        if(n != -1 && n < nv){
            nv= n;
        }

        if(nv != cadena.length){
            return nv;
        }
        return -1;
  }
  generateTargetValue(value: string, currentValue: string,tipo: string) {
        let sdf = 'YYYY/MM/DD HH:mm:ss';
    switch(tipo){
      case 'hours':
        var parts = value.trim().split(":");
        var minutos = Number(parts[0]) * 60 + Number(parts[1]);
        return `${minutos}`
        break;
      case 'date':
      case 'date_range':

        if(value == 'CURRENT'){
          value = moment().format('YYYY/MM/DD');
        }
        var f = moment(`${value} 00:00:00`)
        return `${f.unix()}`;

      break;
      case 'datetime':
      case 'datetime_range':
        var sourceTime = new Date(Number(currentValue)*1000);
        var sourceValor = moment(sourceTime).format(sdf);
        value = value.replace('*',sourceValor.split(' ')[0]);

        if(value.trim() == 'CURRENT'){
          value = moment().format(sdf);
        }else if(value.trim().includes('CURRENT')){
          value = value.replace('CURRENT',moment().format('YYYY/MM/DD'))
        }
        var f = moment(`${value.trim()}:00`)
        return `${f.unix()}`;

      break;
      case 'time':
        var currentday = moment().format('YYYY/MM/DD');
        var f = moment(`${currentday}  ${value}`)
        return `${f.unix()}:00`;
      break;
      default:
        return value;
        break;
    }
  }
  findValueEnd(cadena: string, startOfValue: number) {
            var nv = cadena.length;
        var n = cadena.indexOf("AND",startOfValue);
        if(n != -1 && n < nv){
            nv = n;
        }
        n = cadena.indexOf("OR",startOfValue);
        if(n != -1 && n < nv){
            nv = n;
        }
        n = cadena.indexOf(")",startOfValue);
        if(n != -1 && n < nv){
            nv = n;
        }
        return nv;
  }
  findNextOperatorEnd(cadena: string, startPosition: number) {
     var nv = cadena.length;
        var n = cadena.indexOf("<",startPosition);
        if(n != -1 && n < nv){
            nv = n+1;
        }
        n = cadena.indexOf(">",startPosition);
        if(n != -1 && n < nv){
            nv = n+1;
        }

        n = cadena.indexOf(">=",startPosition);
        if(n != -1 && n <= nv){
            nv= n+2;
        }
        n = cadena.indexOf("<=",startPosition);
        if(n != -1 && n <= nv){
            nv=  n+2;
        }


        if(nv != cadena.length){
            return nv;
        }
        return -1;
  }
  generateSourceValue(value: any,tipo: string) {
    let sdf = 'YYYY/MM/DD HH:mm:ss';
    switch(tipo){
      case 'hours':
        var parts = value.trim().split(":");
        var minutos = Number(parts[0]) * 60 + Number(parts[1]);
        return `${minutos}`
        break;
      case 'date':
      case 'date_range':

        if(value == 'current'){
          value = moment().format('YYYY/MM/DD');
        }

        var f = moment(`${moment(value).format('YYYY/MM/DD')} 00:00:00`)
        return `${f.unix()}`;

      break;
      case 'datetime':
      case 'datetime_range':
        if(value == 'current'){
          value = moment().format(sdf);
        }
        var f = moment(`${moment(value).format(sdf)}`)
        return `${f.unix()}`;

      break;
      case 'time':
        var currentday = moment().format('YYYY/MM/DD');
        var f = moment(`${currentday}  ${value}`)
        return `${f.unix()}`;
      break;
      default:
        return String(value);
        break;
    }
  }
  /**
   * Valida la expresión introducida
   */
  public validaExpresion(expre: string, tipo: string): string {
    if (expre == ""){
      this.expresionValida = true;
      this.resultado = ""
      return this.resultado;
    }
    if (tipo == ""){ //Necesario en el alta
      tipo = this.vTip
    }
    this.resultado = "Valor "
    // expresión regular para validar los operadores
    let operadoresRegex = /(<=|>=|=|<>|<|>|AND|OR)/g;
    let traOperadores = {"<=":"menor o igual que ",">=":"mayor o igual que ","<":"menor que ",">":"mayor que ","<>":"distinto de ","=":"igual que ","AND":" y ","OR":" o "}
    // expresión regular para validar números
    let numerosRegex = /^-?\d+(.\d+)?$/;
    // expresión regular para validar fechas en formato YYYY/MM/DD
    let fechasRegex = /^\d{4}\/\d{2}\/\d{2}$/;
    // expresión regular para validar horas en formato HH:MI
    let horasRegex = /^\d{2}:\d{2}$/;
    // expresión regular para validar fecha y hora en formato YYYY/MM/DD HH:MI
    let fechasHorasRegex = /^\d{4}\/\d{2}\/d{2} \d{2}:\d{2}$/;
    // expresión regular para validar fecha y hora con el uso de "*": "* HH:MI"
    let asteriscoHorasRegex = /^\* \d{2}:\d{2}$/;
    // expresión regular para validar número de horas en formato HH:MI
    let numHoras = /^\d{2}:\d{2}$/;

    this.expresionValida = true;

    // comprobar que los paréntesis están bien balanceados
    let parentesis = 0;
    for (let i = 0; i < expre.length; i++) {
      if (expre[i] === '(') {
        parentesis++;
      } else if (expre[i] === ')') {
        parentesis--;
      }
    }
    if (parentesis !== 0) {
      this.expresionValida = false;
      this.resultado = "No hay el mismo número de paréntesis de apertura que de cierre"
      return this.resultado;
    }
    /*if (!cadEnParentesisRegex.test(expre)) {
      this.resultado = "Dentro de los paréntesis no hay expresiones correctas"
      return this.resultado;
    }*/
    expre = expre.toString().toUpperCase().replace(/\(|\)/g, '');
    // buscar los operadores permitidos (>= y <= tienen que estar antes que =; <> tiene que estar antes de < y > en la expresión regular)
    let operadores = expre.toUpperCase().match(operadoresRegex);

    if (operadores == null) {
      this.expresionValida = false;
      this.resultado = "Al menos debe haber un operador de comparación (<=, >=, =, <, >, <>)"
      return this.resultado;
    } else {
      let palabras = expre.trim().toUpperCase().split(" ")
      let sdf = 'YYYY/MM/DD';

      //Para DATETIME, cuando se encuentre hh:mi:ss, meter ese valor en el elemento anterior y borrar el encontrado
      if (tipo.toUpperCase() == "DATETIME" || tipo.toUpperCase() == "DATETIME_RANGE"){
        for (let i = 1; i< palabras.length; i++) {
          if (horasRegex.test(palabras[i]) ) { // Es hh:mi
            palabras[i - 1] = palabras[i - 1] + " " + palabras[i]
            palabras.splice(i, 1)
          }
        }

        sdf = 'YYYY/MM/DD HH:mm';
      }else if(tipo.toUpperCase() == "HOUR"){
        sdf = 'YYYY/MM/DD HH:mm';
      }

      if (operadores.length < palabras.length){ //No encuentra un operador de comparación o el AND o el OR están mal escritos
        for (let i = 0; i< palabras.length; i++) {
          if (palabras[i].indexOf(operadores[i]) == -1){
            if (tipo.toUpperCase() == "DATETIME" || tipo.toUpperCase() == "DATETIME_RANGE"){
              this.expresionValida = false;
              this.resultado = "La expresión " + palabras[i] + " no forma parte del formato yyyy/mm/dd hh:mi"
              return this.resultado;
            }else{
              this.expresionValida = false;
              this.resultado = "A la expresión " + palabras[i] + " le falta un operador correcto"
              return this.resultado;
            }
          }
        }
        this.expresionValida = false;
      }else if (operadores.length > palabras.length){ //El operador de comparación está mal escrito, pero encuentra los caracteres >, <, = y se confunde
        for (let i = 0; i< palabras.length; i++) {
          let oper = palabras[i].slice(0, palabras[i].indexOf(operadores[i]) + operadores[i].length).trim();
          let val = palabras[i].slice(palabras[i].indexOf(operadores[i]) + operadores[i].length).trim();
          if (val != "") {
            if (tipo.toUpperCase() == "NUMBER"){
              if (!numerosRegex.test(val) ) {
                this.expresionValida = false;
                this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
                return this.resultado;
              }
            } else if (tipo.toUpperCase() == "HOURS"){
              //VALIDACIÓN PARA NÚMERO DE HORAS
              if (!numHoras.test(val)) {
                this.expresionValida = false;
                this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
                return this.resultado;
              }
            } else if (tipo.toUpperCase() == "DATE" || tipo.toUpperCase() == "DATE_RANGE"){
              //VALIDACIÓN PARA DATE
              if (!fechasRegex.test(val) && val != "CURRENT") {
                this.expresionValida = false;
                this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
                return this.resultado;
              }
            } else if (tipo.toUpperCase() == "HOUR"){
              //VALIDACIÓN PARA TIME
              if (!horasRegex.test(val) ) {
                this.expresionValida = false;
                this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
                return this.resultado;
              }
            } else if (tipo.toUpperCase() == "DATETIME" || tipo.toUpperCase() == "DATETIME_RANGE"){
              //VALIDACIÓN PARA DATETIME
              if (!fechasHorasRegex.test(val) && val != "CURRENT" && !asteriscoHorasRegex.test(val)) {
                this.expresionValida = false;
                this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
                return this.resultado;
              }
            }
          }
          if (palabras[i] != oper + val){
            this.expresionValida = false;
            this.resultado = "La expresión " + palabras[i] + " tiene un operador no reconocido"
            return this.resultado;
          }
        }
        this.expresionValida = false;
      }else {
        let expresionAnterior = ""
        let expresionSiguiente = ""
        let exprAEvaluar = expre; //Para evaluar varios AND u OR
        for (let i = 0; i< palabras.length; i++) {
          let valor = palabras[i];
          if (!(valor.startsWith(">=") || valor.startsWith("<=") ||valor.startsWith("<>") || valor.startsWith(">") || valor.startsWith("<") || valor.startsWith("=") || valor.startsWith("AND") || valor.startsWith("OR"))) {
            this.expresionValida = false;
            this.resultado = "El operador de la expresión " + valor + " no es correcto"
            return this.resultado;
          }
          if (operadores[i] === '<=' || operadores[i] === '>=' || operadores[i] === '=' || operadores[i] === '<' || operadores[i] === '>' || operadores[i] === '<>') {
              // comprobar que el operador está seguido de un valor
              // Quitamos el operador al valor para después comprobar si es un valor válido, según su tipo
            valor = palabras[i].slice(palabras[i].indexOf(operadores[i]) + operadores[i].length).trim();
            if (palabras[i] != valor){ //Se ha encontrado un operador
              if (valor != "*"){
                //VALIDACIÓN PARA NUMBER Y HOURS
                if (tipo.toUpperCase() == "NUMBER"){
                  if (!numerosRegex.test(valor) ) {
                    this.expresionValida = false;
                    if (valor != ""){
                      this.resultado = "El valor " + valor + " debe ser un número"
                    }else{
                      this.resultado = "Falta un valor numérico después del operador " + operadores[i]
                    }
                    return this.resultado;
                  }else{
                    this.resultado = this.resultado + traOperadores[operadores[i]] + valor
                  }
                } else if (tipo.toUpperCase() == "HOURS"){
                  if (!numHoras.test(valor) ) {
                    this.expresionValida = false;
                    if (valor != ""){
                      this.resultado = "El valor " + valor + " debe tener formato hh:mi"
                    }else{
                      this.resultado = "Falta un valor de tipo hora y minuto (hh:mi) después del operador " + operadores[i]
                    }
                    return this.resultado;
                  }else{
                    this.resultado = this.resultado + traOperadores[operadores[i]] + valor
                  }
                } else if (tipo.toUpperCase() == "DATE" || tipo.toUpperCase() == "DATE_RANGE"){
                  //VALIDACIÓN PARA DATE
                  if (!fechasRegex.test(valor) && valor != "CURRENT") {
                    this.expresionValida = false;
                    if (valor != ""){
                      this.resultado = "El valor " + valor + " debe ser una fecha con formato yyyy/mm/dd"
                    }else{
                      this.resultado = "Falta un valor de tipo fecha después del operador " + operadores[i]
                    }
                    return this.resultado;
                  }else{
                    if (valor == "CURRENT"){
                      this.resultado = this.resultado + traOperadores[operadores[i]] + "la fecha del reporte"
                    }else if(moment(valor).format(sdf) == 'Invalid date'){
                      this.expresionValida = false;
                      this.resultado = "El valor " + valor + " debe ser una fecha válida"
                    }else{
                      this.resultado = this.resultado + traOperadores[operadores[i]] + valor
                    }
                  }
                } else if (tipo.toUpperCase() == "HOUR"){
                  //VALIDACIÓN PARA TIME
                  if (!horasRegex.test(valor) ) {
                    this.expresionValida = false;
                    if (valor != ""){
                      this.resultado = "El valor " + valor + " debe tener el siguiente formato: hh:mi"
                    }else{
                      this.resultado = "Falta un valor de tipo hora (hh:mi) después del operador " + operadores[i]
                    }
                    return this.resultado;
                  }else if(moment('2000/01/01 '+valor).format(sdf) == 'Invalid date'){
                      this.expresionValida = false;
                      this.resultado = "El valor " + valor + " debe ser una hora válida"

                  }else{
                    this.resultado = this.resultado + traOperadores[operadores[i]] + valor
                  }
                } else if (tipo.toUpperCase() == "DATETIME" || tipo.toUpperCase() == "DATETIME_RANGE"){
                  //VALIDACIÓN PARA DATETIME
                  if (!fechasHorasRegex.test(valor) && valor != "CURRENT" && !asteriscoHorasRegex.test(valor)) {
                    this.expresionValida = false;
                    if (valor != ""){
                      this.resultado = "El valor " + valor + " debe ser una fecha y hora (yyyy/mm/dd hh:mi)"
                    }else{
                      this.resultado = "Falta un valor de tipo fecha y hora (yyyy/mm/dd hh:mi) después del operador " + operadores[i]
                    }
                    return this.resultado;
                  }else{
                    if (valor == "CURRENT"){
                      this.resultado = this.resultado + traOperadores[operadores[i]] + "la fecha y hora del reporte"
                    }else if (asteriscoHorasRegex.test(valor)){
                      this.resultado = this.resultado + traOperadores[operadores[i]] + "las " + valor.split(" ")[1] + " de cualquier día"
                    }else if(moment(valor).format(sdf) == 'Invalid date'){
                      this.expresionValida = false;
                      this.resultado = "El valor " + valor + " debe ser una fecha válida"
                    }else{
                      this.resultado = this.resultado + traOperadores[operadores[i]] + valor
                    }
                  }
                }
              }else{
                this.resultado = this.resultado + " cualquier valor "
              }
            }
          } else if (operadores[i] === 'AND' || operadores[i] === 'OR') {
            // comprobar que el operador está en medio de dos expresiones
            expresionAnterior = exprAEvaluar.slice(0, exprAEvaluar.indexOf(operadores[i])).trim();
            expresionSiguiente = exprAEvaluar.slice(exprAEvaluar.indexOf(operadores[i]) + operadores[i].length).trim();
            exprAEvaluar = expresionSiguiente;
            if (!expresionAnterior){
              this.expresionValida = false;
              this.resultado = "A la expresión " + expresionSiguiente + " le falta una expresión antes del " + operadores[i]
              return this.resultado;
            } else if (!expresionSiguiente){
              this.expresionValida = false;
              this.resultado = "A la expresión " + expresionAnterior + " le falta una expresión después del " + operadores[i]
              return this.resultado;
            }else {
              this.resultado = this.resultado + traOperadores[operadores[i]]
            }
          }
        }
      }
      this.resultado = this.resultado.replace("y igual", "e igual")
      return this.resultado;
    }
  }
}


